var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{staticClass:"math-home",attrs:{"title":_vm.lang == 'zh' ? '亿图公式编辑器' : 'EdrawMath',"mask":true,"showFooter":false,"width":'914',"height":'550'},on:{"ok":_vm.mathOK,"close":_vm.close,"actived":_vm.mathFocus}},[_c('home-body')],1)}
var staticRenderFns = []

export { render, staticRenderFns }